import { guid } from 'services/util';

const GROUP_TO_OPERATOR = {
  is: 'IS',
  not: 'IS_NOT',
  contains: 'CONTAINS',
  notContains: 'NOT_CONTAINS',
  empty: 'IS_EMPTY',
  notEmpty: 'NOT_EMPTY',
  startsWith: 'STARTS_WITH',
  endsWith: 'ENDS_WITH',
};

const OPERATOR_TO_GROUP = {
  IS: 'is',
  IS_NOT: 'not',
  CONTAINS: 'contains',
  NOT_CONTAINS: 'notContains',
  IS_EMPTY: 'empty',
  NOT_EMPTY: 'notEmpty',
  STARTS_WITH: 'startsWith',
  ENDS_WITH: 'endsWith',
};

export const DEFAULT_FILTER_ROW = () => ({
  id: guid(),
  property: { type: 'CONTINENT' },
  operator: 'IS',
  value: [],
});

export const commandsToFilterRows = (commands) => {
  const rows = [];
  const source = commands || {};

  Object.keys(GROUP_TO_OPERATOR).forEach((group) => {
    const entries = source[group];
    if (!Array.isArray(entries) || entries.length === 0) return;

    entries.forEach((entry) => {
      rows.push({
        id: guid(),
        property: { type: (entry.key || '').toUpperCase() },
        operator: entry.operator || GROUP_TO_OPERATOR[group],
        value: entry.values || [],
      });
    });
  });

  return rows.length > 0 ? rows : [DEFAULT_FILTER_ROW()];
};

export const filterRowsToCommands = (rows = []) =>
  rows.reduce((result, row) => {
    const group = OPERATOR_TO_GROUP[row.operator];
    if (!group) return result;

    if (!result[group]) result[group] = [];

    const isEmptyOperator =
      row.operator === 'IS_EMPTY' || row.operator === 'NOT_EMPTY';
    const values =
      isEmptyOperator && (!row.value || row.value.length === 0)
        ? []
        : row.value || [];

    result[group].push({
      key: row.property.type.toLowerCase(),
      operator: row.operator,
      values,
    });

    return result;
  }, {});

export const optimizeCommands = (commands) => {
  if (!commands || typeof commands !== 'object') return {};

  const optimized = {};

  Object.keys(GROUP_TO_OPERATOR).forEach((group) => {
    const entries = commands[group];
    if (!Array.isArray(entries)) return;

    const isEmptyOperator = group === 'empty' || group === 'notEmpty';
    const filtered = entries.filter((entry) => {
      if (!entry) return false;
      if (isEmptyOperator) return true;
      return Array.isArray(entry.values) && entry.values.length > 0;
    });

    if (filtered.length > 0) optimized[group] = filtered;
  });

  return optimized;
};
